﻿import {LocationIsoModalService} from './locationIsoModal.service';
import {LocationIsoModalController} from './locationIsoModal.controller';
import {LocationIsoModalGateway} from './locationIsoModal.gateway';

export default angular.module('idi.core.locationisomodal', ['ui.bootstrap'])
    .service('locationIsoModalService', LocationIsoModalService)
    .service('locationIsoModalGateway', LocationIsoModalGateway)
    .controller('locationIsoModalController', LocationIsoModalController)
    .name;
